import $ from 'jquery'
import 'slick-carousel'
import 'sticky-kit/dist/sticky-kit'

export const renderHotelSlider = (
  slider = document.querySelector('.slider'),
  isHotelMenu = false,
  removeSlider = false
) => {
  const menuSlider = isHotelMenu ? $(slider).find('.menu-slider') : $(slider).find('.menu-slider .fieldset-wrapper')
  const links = menuSlider.find('.anchor-link')
  const checkboxes = menuSlider.find('input:radio')
  const labels =  menuSlider.find('.item label')
  const activeCheckbox = menuSlider.find('input:radio:checked')
  const menuSticky = $('.hotel-menu-sticky')
  let activeLink = $('.hotel-menu-sticky .item a.active')

  if(removeSlider){
    menuSlider.slick('unslick')
    return
  }

  function resizeHandler() {
    setTimeout(() => {
      const adminMenuHeight = parseInt($('body').css('padding-top'), 10)
      const headerHeight = $('.site-header').outerHeight() - $('.site-header__pre-header').outerHeight() + 2 + adminMenuHeight

      menuSticky.trigger('sticky_kit:detach')
      menuSticky.stick_in_parent({
        offset_top: headerHeight,
      })
    })
  }

  if ($(slider).hasClass('hotel-menu')) {
    $('.cookie-banner').find('.btn-close , .btn-holder a').on('click', () => {
      resizeHandler()
    })
    $(window).on('resize', resizeHandler)
    resizeHandler()
    $(window).on('scroll', function () {
      setTimeout(function(){
        $('.hotel-menu-sticky.is_stuck').css('top', $('.site-header').outerHeight())
      })
    })
  }

  const settings = {
    rows: 0,
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 15,
    variableWidth: true,
    swipeToSlide: true,
    focusOnSelect: true,
    accessibility: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 100500,
        },
      },
    ],
  }
  menuSlider.not('.slick-initialized').slick(settings)
  const initialSlide = activeCheckbox.parents('.slick-slide').attr('data-slick-index')
  try {
    menuSlider.slick('unslick')
    menuSlider.slick({ ...settings, initialSlide })
  } catch (e) {
    console.warn(e)
  }

  const headerHeight = $('.site-header').outerHeight() - $('.site-header__pre-header').outerHeight() + 2
  const stickyOffset = headerHeight
  let currentItem = null


  $(window).scroll(() => {
    const scrollDistance = $(window).scrollTop() + stickyOffset + 100
    $('.hotel-menu-sticky .item a.active').removeClass('active')
    const itemsArray = []

    $('.page-anchor').each(function (i, val) {
      if (itemsArray.indexOf(val) === -1 && $(this).position().top <= scrollDistance) {
        activeLink = $(`.hotel-menu-sticky .item a[href="#${val.getAttribute('id')}"]`)
        itemsArray.push(activeLink)
      }
    })
    if (currentItem !== itemsArray[itemsArray.length - 1]) {
      currentItem = itemsArray[itemsArray.length - 1]
      if (currentItem) {
        currentItem.addClass('active')
        const initialSlideLink = currentItem.parents('.slick-slide').attr('data-slick-index')
        menuSlider.slick('slickGoTo', parseInt(initialSlideLink, 10), false)
      }
    }
  }).scroll()

  if (isHotelMenu || !menuSticky) {
    links.each(function () {
      $(this).on('click', function () {
        if(!isHotelMenu){
          links.removeClass('active')
          $(this).addClass('active')
        }

        if(isHotelMenu){
          links.each(function(){
            $(this).parent().removeClass('active')
          })
          $(this).parent().addClass('active')
        }
      })
    })
  }

  checkboxes.parent().removeClass('active')
  activeCheckbox.parent().addClass('active')
  checkboxes.change(() => {
    checkboxes.each((i, el) => {
      if ($(el).prop('checked')) $(el).parent().addClass('active')
      else $(el).parent().removeClass('active')
    })
  })


  labels.on('keypress', function (e) {
    if (
        e.type === "keydown" &&
        e.key !== "Enter" &&
        e.key !== " "
    ) {
      return
    }
    $(this).find('input').click()
  })

}
